var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57632 16.1612C4.71121 16.0263 4.89249 15.9504 5.08219 15.9504H22.6402C22.9606 15.9504 23.1208 16.3383 22.8931 16.5617L19.4237 20.0311C19.2888 20.166 19.1075 20.2419 18.9178 20.2419H1.35981C1.03942 20.2419 0.879228 19.8541 1.10687 19.6307L4.57632 16.1612Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57632 3.21078C4.71121 3.07588 4.89249 3 5.08219 3H22.6402C22.9606 3 23.1208 3.38784 22.8931 3.61126L19.4237 7.07649C19.2888 7.21139 19.1075 7.28727 18.9178 7.28727H1.35981C1.03942 7.28727 0.879228 6.89944 1.10687 6.67601L4.57632 3.21078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4237 9.64364C19.2888 9.50874 19.1075 9.43286 18.9178 9.43286H1.35981C1.03942 9.43286 0.879228 9.8207 1.10687 10.0441L4.57632 13.5094C4.71121 13.6443 4.89249 13.7201 5.08219 13.7201H22.6402C22.9606 13.7201 23.1208 13.3323 22.8931 13.1089L19.4237 9.64364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.b12871a58a609707929cc8ba4178b96c.svg";
export { ForwardRef as ReactComponent };